<template>
    <div>
        <div class="white-box white-box-no-tab text-base xs:text-lg pb-10">
            <Title
                styleCodePage
                :text="`${$route.meta.pageTitle}(${applyWay?.name})`"
            />

            <h4 class="py-3 md:pb-3.5 md:pt-0">
                請輸入相關授權資訊
            </h4>
            <Skeletons v-if="isLoading" />
            <template v-else>
                <ul class="text-tip mb-2.5">
                    <li>僅限授權予要保人本人之帳戶</li>
                </ul>
                <AccountTable
                    class="hidden lg:block"
                    :data="userInfo"
                >
                    <template #input>
                        <input
                            v-model.trim="bankAccount"
                            name="bankAccount"
                            type="text"
                            class="input-base w-full"
                            placeholder="請輸入授權銀行帳號"
                            autocomplete="off"
                            inputmode="numeric"
                            @input="validateBankAccount"
                        >
                        <p class="error-msg">
                            {{ errorMessage.bankAccount }}
                        </p>
                    </template>
                </AccountTable>
                <AccountList
                    class="lg:hidden"
                    :data="userInfo"
                >
                    <template #input>
                        <input
                            v-model.trim="bankAccount"
                            name="bankAccount"
                            type="text"
                            class="input-base max-w-[18rem]"
                            placeholder="請輸入授權銀行帳號"
                            autocomplete="off"
                            inputmode="numeric"
                            @input="validateBankAccount"
                        >
                        <p class="error-msg">
                            {{ errorMessage.bankAccount }}
                        </p>
                    </template>
                </AccountList>
            </template>
        </div>
        <Bottombar>
            <template #right>
                <button
                    class="btn btn-accent rounded-full"
                    :disabled="!bankAccount"
                    @click="goNext()"
                >
                    下一步
                </button>
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, reactive, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Title from '@/components/text/Title.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Loading from '@/components/Loading.vue';
import AccountTable from './AccountTable.vue';
import AccountList from './AccountList.vue';
import routeName from '@/router/constant.js';
import Skeletons from './Skeletons.vue';
import { integer } from '@/utils/rules/customRules';
import { submitBankACH } from '@/apis/aplCatlACH.js';
import dialogContnet from '@/json/dialogContent.js';
import codeList from '@/json/codeList.js';

export default {
    components: {
        Title,
        Bottombar,
        Loading,
        AccountTable,
        AccountList,
        Skeletons
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const store = useStore();
        const isDisableButton = ref(false);
        const isLoading = ref(false);
        const applyWay = computed(() => store.state.services.changeItemsResult[`${code}applyWay`]);
        const userInfo = computed(() => store.state.services.changeItemsResult[code]);
        const bankAccount = ref('');
        const errorMessage = reactive({});
        const code = codeList.ACH;

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };
        if (userInfo.value) {
            bankAccount.value = userInfo.value.bankAccount;
            // 380168791280
        }
        const goNext = () => {
            if (errorMessage.bankAccount) {
                modalShow(dialogContnet.validateMsg);
                return;
            }
            if (!bankAccount.value) {
                modalShow(dialogContnet.validEmptyMsg);
                return;
            }
            isLoading.value = true;
            const data = {
                bankAccount: bankAccount.value
            };
            submitBankACH(data).then(() => {
                store.dispatch('services/setChangeItemsResult', { code, value: { ...userInfo.value, ...data } });
                router.push({ name: routeName.CONFIRM_DATA });
                isLoading.value = false;
            }).catch(err => {
                isLoading.value = false;
                const errData = err.data?.details.map(i => `<li>${i.errorMessage}</li>`) || [];
                const params = {
                    title: '請調整資料格式',
                    content: `<ul class="space-y-2 list-decimal ml-6" >${errData.join('')}</ul>`,
                    confirmButton: '確認',
                    closeicon: false,
                };
                modalShow(params);
            });
        };
        // 驗證數字欄位
        const validateBankAccount = () => {
            errorMessage.bankAccount = integer(bankAccount.value, '請輸入數字') || '';
        };
        return {
            isDisableButton,
            isLoading,
            errorMessage,
            goNext,
            validateBankAccount,
            bankAccount,
            applyWay,
            userInfo
        };
    },
};
</script>
